import React, { useState, useEffect } from 'react';

import { Box, Typography } from '@mui/material';

import Logo from 'src/components/logo/logo';

function ScreenWidthGuard({ children, minWidth = 768 }) {
  const [isSupportedWidth, setIsSupportedWidth] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setIsSupportedWidth(window.innerWidth >= minWidth);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [minWidth]);

  if (isSupportedWidth) {
    return <>{children}</>;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        textAlign: 'center',
        flexDirection: 'column',
        gap: 2,
        p: 2,
      }}
    >
      <Logo sx={{ width: 120 }} />
      <Typography variant="h4" color="primary.main">
        소형 화면에서는 이용할 수 없습니다.
        <br /> 태블릿 또는 데스크탑에서 이용해주세요.
      </Typography>
    </Box>
  );
}

export default ScreenWidthGuard;
